import {
  httpRequest
} from "../../assets/js/request"

export function getList(id,type) {
    return httpRequest({
      url: '/app/share/sx/'+type+'/'+id,
      method: 'get',
    })
  }
